import React, { useState, useEffect } from 'react';
import { Form } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { notification } from 'antd';
import Input from 'components/Atom/Input';
import { Button } from 'components/Atom/Button';
import './assets/style.css';
import { resetPassword } from 'utils/copilot';
import { clearStorage } from '../../utils/storage';

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const currentYear = new Date().getFullYear();

  const search = location.search;
  const authToken = new URLSearchParams(search).get('auth_token');
  const emailType = new URLSearchParams(search).get('action_type');

  useEffect(() => {
    if (!authToken) {
      navigate('/auth/login');
    }
  }, [authToken, navigate]);

  const onSubmit = async (values) => {
    if (values.password !== values.confirmPassword) {
      notification.error({
        message: 'Error',
        description: 'Passwords do not match',
        placement: 'bottomRight',
      });
      return;
    }

    setLoading(true);
    try {
      const response = await resetPassword(
        {
          password: values.password,
          confirmPassword: values.confirmPassword,
        },
        authToken
      );

      if (response?.data) {
        notification.success({
          message: 'Success',
          description: emailType !== 'accountActivation' ? 'Your password has been reset successfully.' : 'Password has been set successfully.',
          placement: 'bottomRight',
        });
        clearStorage();
        navigate('/auth/login');
      }
    } catch (err) {
      notification.error({
        message: 'Error',
        description: err?.response?.message || 'Something went wrong',
        placement: 'bottomRight',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='login-wrapper'>
      <div className='login-form login-bg-wrapper'>
        <div className='form-wrapper'>
          <img className='logo' alt='Xpay logo' src='/XPay.svg' />
          <div className='welcome-text'>
            <p className='heading'>{emailType !== 'accountActivation' ? 'Reset Your Password' : 'Set New Password'}</p>
            <div className='subtext'>Please enter your new password</div>
          </div>

          <div className=''>
            <Form form={form} layout='vertical' onFinish={onSubmit}>
              <Form.Item
                name='password'
                label='New Password'
                className='customInputPass mobileInputView'
                dependencies={['confirmPassword']}
                rules={[
                  {
                    validator: (_, value) => {
                      const pattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&^_-])[A-Za-z\d@$!%*#?&^_-]{8,}$/;
                      if (!value) {
                        return Promise.reject(new Error('Password is required'));
                      }
                      if (!pattern.test(value)) {
                        return Promise.reject(new Error('Password must be at least 8 characters long and contain at least one letter, one number, and one special character'));
                      }
                      const confirmPassword = form.getFieldValue('confirmPassword');
                      if (confirmPassword) {
                        setTimeout(() => {
                          form.validateFields(['confirmPassword']).catch(() => {});
                        }, 0);
                      }

                      return Promise.resolve();
                    },
                  },
                ]}>
                <Input placeholder='Enter new password' name='password' type='password' className='input-placeholder' />
              </Form.Item>

              <Form.Item
                name='confirmPassword'
                label='Confirm Password'
                className='customInputPass mobileInputView'
                dependencies={['password']}
                rules={[
                  {
                    validator: (_, value) => {
                      const password = form.getFieldValue('password');
                      if (!value) {
                        return Promise.reject(new Error('Please confirm your password'));
                      }
                      if (password && value !== password) {
                        return Promise.reject(new Error('Passwords do not match'));
                      }

                      return Promise.resolve();
                    },
                  },
                ]}>
                <Input placeholder='Confirm new password' name='confirmPassword' type='password' className='input-placeholder' />
              </Form.Item>

              <div className=''>
                <Form.Item>
                  <div style={{ display: 'flex', justifyContent: 'right', marginTop: '8px' }}>
                    <Button block className='button-theme rounded-lg' htmlType='submit' loading={loading}>
                      {emailType !== 'accountActivation' ? 'Reset Password' : 'Set Password'}
                    </Button>
                  </div>
                </Form.Item>
              </div>
            </Form>
          </div>
        </div>

        <div className='form-footer-note pb-6'>
          <div className='copyright'>
            <a href='https://xpay.postexglobal.com' target='_blank' rel='noopener noreferrer' className='pr-2 hover:underline' style={{ color: '#4f4d55' }}>
              ©{currentYear} PostEx.
            </a>{' '}
          </div>
          <p className='terms'>
            <a href='https://xpay.postexglobal.com' target='_blank' rel='noopener noreferrer' className='pr-2 hover:underline'>
              Terms of Service
            </a>
            |
            <a href='https://xpay.postexglobal.com' target='_blank' rel='noopener noreferrer' className='pl-2 hover:underline'>
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
      <div>
        <img src='/loginImage.svg' alt='image' />
      </div>
    </div>
  );
};

export default ResetPassword;
